module.exports = __webpack_public_path__ + "img/slider-6-mobile.dde51304.png";